import { resolveImagemUrl } from '@/utils/imagemUrl';

export default {
  namespaced: true,
  state: () => ({
    exFamComerc: [],
    filters: {
      page: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: null,
    },
  }),
  mutations: {
    setExFamComerc(state, payload) {
      state.exFamComerc = payload.map((i) => ({
        ...i,
        caminho: resolveImagemUrl(i.caminho),
      }));
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setPage(state, payload) {
      state.filters.page = payload;
    },
  },
  getters: {
    getExFamComerc(state) {
      return state.exFamComerc;
    },
    getFilters(state) {
      return state.filters;
    },
  },
};
